<template>
  <div>
    <div v-if="isLoading" class="text-center my-4">
      <scale-loader></scale-loader>
    </div>
    <div v-else>
      <div class="panel" v-if="ready">
        <form @submit.prevent="updateGroup">

          <!-- Parent Group Name Display -->
          <div v-if="parentGroupName" class="mb-4 p-3 bg-gray-100 rounded">
            <label class="text-sm font-medium text-gray-600">{{ $t('add_subgroup') }}:</label>
            <span class="ml-2 text-gray-800">{{ parentGroupName }}</span>
          </div>

          <div class="w-1/3 flex-col">

            <div class="flex-col">
              <label form="name_id">{{ $t('name')}}</label>
              <v-input
                title="name"
                id="name_id"
                required="true"
                v-model="formChangeGroup.name"
                name="name"
                placeholder="name"
              />
            </div>

            <div class="flex-col mt-4">
              <label form="description_id">{{ $t('description')}}</label>
              <v-input
                title="description"
                id="description_id"
                v-model="formChangeGroup.description"
                name="description"
                placeholder="description"
              />
            </div>

            <!-- Imagen del grupo -->
            <div class="flex-col mt-4">
              <b-field class="file is-primary" :class="{'has-name': !!this.image}" v-if="this.groupId && !this.isCreatingSubgroup">
                <div class="w-1/2 pr-4">
                  <label class="label">{{$t('group_image')}}</label>
                  <img :src="this.image" class="w-full" v-if="this.image" style="box-shadow: 1px 1px 3px #d5d5d5">
                  <div v-else><scale-loader></scale-loader></div>
                </div>
                <div class="w-1/2 pr-4">
                  <label class="label">{{$t('change_image')}}</label>
                  <b-upload  class="file-label" @input="uploadImage">
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload" pack="fas"></b-icon>
                      <span class="file-label">{{$t('upload_image')}}</span>
                    </span>
                  </b-upload>
                </div>
              </b-field>
            </div>

            <div class="flex-col mt-4">
              <label form="projects_id">{{ $t('projects_associated')}}</label>
              <b-taginput
                v-model="formChangeGroup.projects"
                :data="filteredProjects"
                autocomplete
                field="name"
                :placeholder="$t('select_project_menu')"
                @typing="getFilteredProjects">
                <template v-slot="props">
                    {{props.option.name}}
                </template>
                <template #empty>
                    {{ $t('empty_projects') }}
                </template>
            </b-taginput>
            </div>

            <div class="flex flex-row mt-4">
                <button class="btn btn-blue" nativeType="submit">
                  {{$t('save')}}
                </button>

                <a @click="$router.go(-1)" class="btn btn-light ml-2">
                  {{$t('cancel')}}
                </a>
            </div>

          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Form from 'vform'
  import axios from 'axios'
  import store from '~/store'
  import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

  export default {
    middleware: 'auth',
    // title: 'userform_page_title',
    // subtitle: 'userform_page_subtitle',
    menuOption: '0-2',

    components: {
      ScaleLoader
    },

    data: () => ({
      formChangeGroup: new Form({
        name: '',
        description: null,
        projects: null
      }),
      ready: false,
      groupId: 0,
      parentId: null,
      parentGroupName: '',
      subgroupId: null,
      isLoading: false,
      isSelectOnly: false,
      projects: [],
      filteredProjects: [],
      isCreatingSubgroup: false,
      image: '',
    }),

    created(){
      this.getProjects();

    },
    mounted() {
      let self = this

      // Capturamos ID del grupo si existe
      this.groupId = store.state.route.params.id;
      if (store.state.route.fullPath.includes('/subgroup')) {
        if (!this.groupId) {
          this.$router.go(-1)
          return
        }
        this.isCreatingSubgroup = true;
      }


      if (this.groupId) {
        this.groupId = parseInt(this.groupId)
        this.getGroup()
      } else {
        this.ready = true
      }
    },

    methods: {
      async getProjects(){
        const { data } = await axios.get("/api/v2/user/projects", {'params' : { showArchive : 1, group: null, mappedForSelect: true }});
        this.filteredProjects = data.projects;
        this.projects = data.projects;
      },

      getFilteredProjects(text) {
        this.filteredProjects = this.projects.filter((option) => {
            return option.name
                .toString()
                .toLowerCase()
                .indexOf(text.toLowerCase()) >= 0
        })
      },

      getGroup() {
        let self = this;
        axios.get('/api/v2/group/' + this.groupId)
          .then(function (response) {
            if (self.isCreatingSubgroup) {
              self.parentId = response.data.data.id;
              self.parentGroupName = response.data.data.name;
              self.ready = true
            } else {
              self.formChangeGroup.name = response.data.data.name;
              self.formChangeGroup.description = response.data.data.description;
              self.formChangeGroup.projects = response.data.data.projects;
              self.image = response.data.data.image;
              self.ready = true
            }
          })
          .catch(function (error) {
            self.$notify.error('error_retreving_group_info')
          });
      },

      async updateGroup() {

        let formData = new FormData();
        formData.append('name', this.formChangeGroup.name);
        
        // Only append description if it's not empty or null
        if (this.formChangeGroup.description && this.formChangeGroup.description.trim() !== '') {
          formData.append('description', this.formChangeGroup.description);
        }
        
        formData.append('projects', JSON.stringify(this.formChangeGroup.projects));
        if (this.isCreatingSubgroup && this.parentId) {
          formData.append('parent_id', this.parentId);
        }


        var url = this.groupId ? '/api/v2/group/' + this.groupId : '/api/v2/group'
        if (this.isCreatingSubgroup) {
          url = '/api/v2/group'
        }

        let self = this
        this.isLoading = true

        await axios.post(url, formData)
          .then(function (response) {
            self.isLoading = false
            if (response.data.success == true) {
              self.$notify.success('group_edited')

              if (url.endsWith('/' + response.data.group.id)) {
                self.$router.push({
                  name: 'admin.groups'
                })
              } else {
                self.image = response.data.group.image
                self.groupId = response.data.group.id
                if (self.isCreatingSubgroup) {
                  self.isCreatingSubgroup = false
                  self.$router.replace({
                    name: 'admin.group',
                    params: { id: response.data.group.id }
                  })
                }
              }

            }
          })
          .catch(error => {
            self.isLoading = false
            console.log(error.response);
            self.$notify.error(error.response);

          });

      },

      async uploadImage(file) {
        let url = "/api/v2/group/" + this.groupId + "/image";

        let self = this
        self.image=''; // reset image, show 'uploading...'

        const formData = new FormData();
        formData.append('image', file);

        await axios.post(url, formData)
          .then(function (response) {
            if (response.data.success && response.data.image) {
                self.image = response.data.image;
            }
            else
              console.log('Error uploading image',response);
          })
      },
    },
  };
</script>
